export const theme = {
  colors: {
    // Brand
    white: '#fff',

    // OSchool colors
    kinkyPurple: '#12002E',
    linkPurple: '#5E64BF',
    linkIconPurple: '#5458B4',
    linkTextGrey: '#A392B9',
    pink: '#FF00AB',
    red: '#D00246',
    blue: '#066aff',
    teal: '#77FFE0',
    orange: '#FF923F',
    purple: '#11002E',
    yellow: '#FFDF00',
    animalPink: '#E94EBB',
    animalBlue: '#200FB7',
    animalPurple: '#8B00FF',
    animalRed: '#F54242',
    animalOrange: '#FF8700',
    animalGreen: '#63D863',
    animalLightBlue: '#00BDFF',

    // Semantic
    positive: '#68D17F',
    negative: '#7D0C0C',
    warning: '#E5A847',

    // Font
    fontNavy: '#0C457D',
    fontGrey: '#9DB4CB',
    fontFade: '#6EA4D9',

    // Fades
    blackfade15: 'rgba(27, 31, 35, 0.15)',
    blackfade20: 'rgba(27, 31, 35, 0.20)',
    blackfade35: 'rgba(27, 31, 35, 0.35)',
    blackfade50: 'rgba(27, 31, 35, 0.5)',
    whitefade15: 'rgba(255, 255, 255, 0.15)',
    whitefade20: 'rgba(255, 255, 255, 0.20)',
    whitefade35: 'rgba(255, 255, 255, 0.35)',
    whitefade50: 'rgba(255, 255, 255, 0.5)',
  },
  breakpoints: ['375px', '768px', '1012px', '1280px'],
  maxWidths: {
    small: '375px',
    medium: '768px',
    large: '1012px',
    xlarge: '1280px',
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    normal: 'apple-system, BlinkMacSystemFont, Roboto',
  },
  radii: [0, 2, 4],
  shadows: {
    small: '0 2px 4px 0 rgba(12,69,125,0.06)',
    medium: '0 4px 8px 0 rgba(12,69,125,0.14)',
    input: '0 0 4px 0 #C5D9EC',
    inputFocus: '0 0 6px 0 #6BD2DB',
  },
  zIndices: {
    modal: 6000,
    overlay: 4000,
    dropdown: 3000,
    layerThree: 2500,
    layerTwo: 2000,
    layerOne: 1500,
    foreground: 1000,
    background: -1000,
  },
}
